/** Executa trabalho assíncrono sem propagar Promise ao caller (Sonar S6544). */
const dispatchAsync = (work: () => Promise<unknown>): void => {
	work().catch(() => undefined);
};

export { dispatchAsync };
